import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback } from 'react';
import { fetchAggResponse } from '../../../common';
import { ToggleDefinitionMutation } from '../gql/toggle-definition-mutation';
export var useToggleDefinitionSupplier = function useToggleDefinitionSupplier() {
  var toggleDefinition = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var workspaceId, keyPhrase, isDisabled;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            workspaceId = _ref.workspaceId, keyPhrase = _ref.keyPhrase, isDisabled = _ref.isDisabled;
            return _context.abrupt("return", fetchAggResponse({
              graphQuery: ToggleDefinitionMutation,
              variables: {
                workspaceId: workspaceId,
                keyPhrase: keyPhrase,
                isDisabled: isDisabled
              }
            }).then(function (response) {
              var _response$data;
              if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && (_response$data = _response$data.knowledgeDiscovery.updateUserKeyPhraseInteraction) !== null && _response$data !== void 0 && _response$data.success) {
                return {
                  toggleDefinitionSuccess: true
                };
              } else {
                throw new Error('toggleDefinition mutation unsuccessful');
              }
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  return {
    toggleDefinition: toggleDefinition
  };
};